import SlidePreviewer from './previewer.vue';
import { $, getJson, timeout } from 'donot';
import { createApp, onMounted, ref } from 'vue';

const $body = $("body");
const API_ENDPOINT = $('[rel="https://api.w.org/"]').getAttribute('href');
let scrollPosition = 0;

async function fetchSlide(stid) {
    const url = `${API_ENDPOINT}st/slide/${stid}`;
    return await getJson(url);
}

function getStid(str) {
    return /ST-\d{6}(?:-\d{2})*/.exec(str);
}

export function  previewer(el) {
    const app = createApp({
        components : { SlidePreviewer },

        setup() {
            const currentStid = ref(-1);
            const error = ref(null);
            const loadingStid = ref(-1);
            const loading = ref(false);
            const showContent = ref(false);
            const showWrapper = ref(false);
            const slide = ref(null);

            async function close() {
                loading.value = false;
                loadingStid.value = -1;

                if (showContent.value) {
                    showContent.value = false;
                    await timeout(500);
                }

                showWrapper.value = false;
                error.value = null;
                unlockBody();
            }

            function handleKeys(e) {
                if (e.key === 'Escape') {
                    window.location.hash = '';
                }
            }

            function lockBody() {
                // Fix the body, otherwise people can just scroll if they want
                scrollPosition = window.scrollY;
                $body.style.top = -scrollPosition + 'px';
                $body.setAttribute('fix-position', 'fix-position');

                // Let people click outside of the frame to go back as well
                el.addEventListener('click', (e) => {
                    if (e.target.classList.contains('previewer')) {
                        close();
                    }
                });

                window.addEventListener('keydown', handleKeys, false);
            }

            function parseHash() {
                const hash = window.location.hash.slice(1);

                if (!hash) {
                    close();
                    return;
                }

                const stid = getStid(hash);

                if (!stid) {
                    close();
                    return;
                }

                preview(stid[0]);
            }

            async function preview(stid) {
                if (loading.value) {
                    return;
                }

                loading.value = true;

                if (!currentStid.value) {
                    showContent.value = false;
                }

                loadingStid.value = stid;
                currentStid.value = stid;

                try {
                    slide.value = await fetchSlide(stid);
                } catch (e) {
                    // If we get an error, close the whole thing
                    console.error(e);
                    showError("Unfortunately we can't show you this slide because of a technical error.");
                    return;
                }

                loading.value = false;
                loadingStid.value = -1;

                if (!showContent.value) {
                    show();
                }
            }

            function setPreviewHash(stid) {
                window.location.href = `#/preview/${stid}`;
            }

            async function show() {
                lockBody();
                showWrapper.value = true;
                await timeout(500);
                showContent.value = true;
            }

            async function showError(err) {
                showContent.value = false;
                loading.value = false;
                loadingStid.value = -1;
                error.value = err;
                lockBody();
                showWrapper.value = true;
                await timeout(500);
            }

            function unlockBody() {
                $body.removeAttribute('fix-position');
                $body.style.top = null;
                window.scrollTo(0, scrollPosition);

                // Make sure to remove the listener for escaping the page as well
                window.removeEventListener('keydown', handleKeys, false);
            }

            onMounted(() => {
                window.addEventListener('hashchange', () => parseHash());
                parseHash();
            });

            return {
                error,
                loading,
                loadingStid,
                setPreviewHash,
                showContent,
                showWrapper,
                slide
            }
        }
    });

    app.mount(el);
}